module.exports = __webpack_public_path__ + "img/novelty-frame-pc.bf4bb2d7.png";